// eslint-disable-next-line require-jsdoc
export async function getCompanyById(companyId: String) {
  return fetch('/companies/' + companyId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(async (response) => {
    return {
      body: await response.json(),
      status: response.status
    };
  });
}
